/**
 * IMBEE-8954 / T113 — the `GET /widget` → website-tracking entitlement read.
 *
 * Mirrors `campaign/config.ts` exactly, and lives here for the same reason: a field read is unit
 * testable on its own, whereas reaching it through `App` costs a full widget mount.
 *
 * Fail-closed: absent, malformed or non-`true` all read as NOT entitled, so a non-entitled tenant
 * adds no request to any page load.
 *
 * Deliberately a SEPARATE flag from `liveChatCampaigns.enabled`. Campaigns consume activity, so
 * reusing that flag looks harmless — but pausing campaigns would then silently stop collecting the
 * very data campaigns depend on.
 */
export const resolveWebsiteTrackingEnabled = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') return false;
  const websiteTracking = (data as Record<string, unknown>).websiteTracking;
  if (!websiteTracking || typeof websiteTracking !== 'object') return false;
  return (websiteTracking as Record<string, unknown>).enabled === true;
};
